<template>
  <div v-if="propValidationIsValid">
    <div class="d-flex justify-content-center flex-column flex-md-row justify-content-md-start align-items-md-center">
      <h4 class="mr-3 mb-1">
        {{graphTitle}}
      </h4>
      <div class="form-group mb-1 statistics-multiselect">
        <multiselect
          v-model="selectedCriteria"
          :options="graph.criterias"
          v-if="showCriteriasSelection"
          track-by="id"
          label="name"
          select-label=""
          selected-label=""
          deselect-label=""
          :placeholder="$t('agenda.statistics.criteria.placeholder')"
          :allow-empty="false"
          :multiple="false"
          :searchable="true"
          :limit="10">
          <span slot="noResult">{{$t('patients.noResults')}}</span>
        </multiselect>
      </div>
    </div>
    <div class="graph__content mt-3">
      <base-graph
        :graphOptions="graph"
        :dataset="datasetOrdered"
        :datasetKey="graph.dataset_key"
        :pagination="pagination">
      </base-graph>
      <br>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import BaseGraph from './BaseGraph'
import PropValidation from '@/mixins/PropValidationMixin'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'

export default {
  components: {
    BaseGraph,
    Multiselect
  },
  props: {
    /*
    {
      name: The title that should be displayed in the graph
      dataset_key: The key in the dataset that will draw under each element in the graph
      // Array of labels that are displayed at the end of the graph
      labels: [
        {
          color: The color of the given label,
          key: The key that is in the dataset that represents this label
          label: the text of the given label
        }
      ],
      // Array of criterias that will order the dataset.. its required at least one criteria
      criterias: [
        {
          name: The name of the given criteria,
          criteria: a function that will sort elements in the dataset
        }
      ]
    }
    */
    graph: {
      type: Object,
      required: true,
      validator: (graph) => {
        let requiredKeys = ['labels', 'criterias', 'dataset', 'dataset_key']

        let graphOptionsHasRequiredKeys = requiredKeys.every(key => {
          return graph.hasOwnProperty(key)
        })

        let everyDatasetItemContainsLabels = graph['dataset'].every(item => {
          return graph['labels'].every(element => {
            return item.hasOwnProperty(element.key) && item.hasOwnProperty(graph.dataset_key)
          })
        })

        let criteriasAreValid = Array.isArray(graph.criterias) && graph.criterias.length > 0 && graph['criterias'].every(criteria => {
          return (criteria.hasOwnProperty('name') &&
            criteria.hasOwnProperty('criteria') &&
            typeof criteria.name === 'string' &&
            typeof criteria.criteria === 'function')
        })

        return graphOptionsHasRequiredKeys && everyDatasetItemContainsLabels && criteriasAreValid
      }
    },
    showCriteriasSelection: {
      type: Boolean,
      required: false,
      default: true
    },
    pagination: {
      type: Object,
      required: false,
      default: () => {
        return {
          show: true,
          perPage: 5
        }
      },
      validator: (options) => {
        return options.hasOwnProperty('show') && options.hasOwnProperty('perPage')
      }
    }
  },
  mixins: [PropValidation],
  data () {
    return {
      selectedCriteria: this.graph.criterias.length ? this.graph.criterias[0] : null
    }
  },
  created () {
    this.parseFromLocalStorage()
  },
  methods: {
    parseToLocalStorage: function () {
      if (this.graph.localStorageKey) {
        let state = LocalStorageHelper.get(this.graph.localStorageKey)
        LocalStorageHelper.set(this.graph.localStorageKey, {
          ...state,
          criteria: this.selectedCriteria.id
        })
      }
    },
    parseFromLocalStorage: function () {
      let state = LocalStorageHelper.get(this.graph.localStorageKey)
      if (state) {
        if (state.hasOwnProperty('criteria')) {
          let criteria = parseInt(state.criteria)
          this.selectedCriteria = this.graph.criterias.length ? this.graph.criterias.find(_criteria => _criteria.id === criteria) : null
        }
      }
    }
  },
  computed: {
    graphTitle: function () {
      return this.graph.name || this.$t('agenda.statistics.graphs.title')
    },
    activeSortMethod: function () {
      return this.selectedCriteria ? this.selectedCriteria.criteria : null
    },
    datasetOrdered: function () {
      if (this.activeSortMethod) {
        return this.graph.dataset.slice(0).sort(this.activeSortMethod)
      }
      return null
    },
    graphTypes: function () {
      return {
        ...this.graph,
        dataset: this.datasetOrdered || []
      }
    },
  },
  watch: {
    selectedCriteria: {
      handler: function (criteria) {
        this.parseToLocalStorage()
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
.statistics-multiselect{
  min-width: 400px;
  max-width: 40%;
}

@media only screen and (max-width: 768px) {
  .statistics-multiselect {
    min-width: 100%;
  }
}
</style>
